import React from "react";
import FileUploadSingle from "../../../../form/FileUploadSingle";
import { SketchPicker } from "react-color";
import PopoverDropdown from "../../../../elements/PopoverDropdown";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setThemeValue } from "../../../../../redux/slice/themeSlice";
import { rgba } from "../../../../../helpers";

const LogoTool = ({ element }) => {
  const dispatch = useDispatch();
  const { theme, selectedElement } = useSelector(
    (state) => state?.themeProvider
  );

  return (
    <div className="space-y-4">
      <FileUploadSingle
        label={"Logo upload"}
        accept={"jpg,png,jpeg"}
        value={theme?.[element]?.url || theme?.[element]}
        onChange={(file) => dispatch(setThemeValue({ [element]: file }))}
      />
      <PopoverDropdown
        buttonLabel={
          <div className="flex items-center space-x-2">
            {theme?.customiseLogo?.backgroundColor && (
              <span
                className="w-6 h-6 flex rounded"
                style={{
                  backgroundColor: rgba(theme?.customiseLogo?.backgroundColor),
                }}
              ></span>
            )}
            <span>Select colour</span>
          </div>
        }
        buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
        contentClass="border-0 p-0 !min-w-fit bg-transparent"
      >
        <SketchPicker
          className="!shadow-none !border-0"
          color={theme?.customiseLogo?.backgroundColor}
          onChange={(e) => {
            dispatch(
              setThemeValue({
                customiseLogo: {
                  ...theme?.customiseLogo,
                  backgroundColor: e.rgb,
                },
              })
            );
          }}
        />
      </PopoverDropdown>
    </div>
  );
};

export default LogoTool;
